import { Resources } from 'constants/resources';

import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { GatewayMethodField } from 'pages/Gateways/GatewaysEdit/hooks/useGatewayMethodsFieldArray';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from 'shared/mui/Link/Link';
import { TableBody, TableCell, TableHead, TableRow } from 'shared/mui/Table';
import { TooltipWithInfoIcon } from 'shared/mui/Tooltip';

import { StyledBooleanInput, StyledTable } from './GatewaysEditPilotSettings.styled';

type Props = {
  gatewayMethodFields: GatewayMethodField[];
};

export const GatewaysEditPilotSettingsTable = ({ gatewayMethodFields }: Props) => {
  const { createPathWithQuery } = useCreatePathWithQuery();

  return (
    <StyledTable size="small">
      <TableHead
        sx={{
          backgroundColor: 'tableHead',
        }}
      >
        <TableRow>
          <TableCell>Метод</TableCell>
          <TableCell width={89}>Активен</TableCell>
          <TableCell width={127}>Тестирование</TableCell>
          <TableCell width={179}>
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                paddingTop: '5px',
              }}
            >
              <span style={{ marginRight: '4px' }}>Автоотключение</span>
              <span style={{ marginTop: '-6px' }}>
                <TooltipWithInfoIcon tooltipText="Режим тестирования будет отключён при создании первого заказа в системе." />
              </span>
            </div>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {gatewayMethodFields.map((field, index) => (
          <TableRow key={field.id}>
            <TableCell>
              <Link
                component={RouterLink}
                style={{ textDecoration: 'none', color: 'primary.main' }}
                target="_blank"
                to={createPathWithQuery({
                  resource: Resources.Methods,
                  id: field.method,
                  type: 'show',
                })}
              >
                {field.methodName}
              </Link>
            </TableCell>
            <TableCell>
              <StyledBooleanInput
                label={false}
                size="small"
                source={`gatewayMethods.${index}.active`}
              />
            </TableCell>
            <TableCell>
              <StyledBooleanInput
                label={false}
                size="small"
                source={`gatewayMethods.${index}.pilotMode`}
              />
            </TableCell>
            <TableCell>
              <StyledBooleanInput
                label={false}
                size="small"
                source={`gatewayMethods.${index}.autoDeactivation`}
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </StyledTable>
  );
};
